import { Theme, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ILoginContext } from 'context';
import { useLogin } from 'hooks';
import { Spinner } from 'components';
import { LoginForm, SelectClinicForm, ForgotPasswordForm, ResetPasswordForm, Login2Fa } from './components';

import styles from './LoginPage.module.scss';
import image from '../../assets/images/LoginLeftImage.png';
import { isHipaaLink } from 'config/productProfile';

export function LoginPage() {
  const { t, i18n } = useTranslation('auth');
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { loading, loginModelData, loginPageState }: ILoginContext = useLogin();

  const handleSignupClick = (): void => {
    navigate('../register', { replace: true });
  };

  return (
    <div className={styles.main}>
      {isMobile ? (
        <>
          <div className={styles.rightSide}>
            <div className={styles.loginContainer}>
              {loading && <Spinner small />}
              {loginPageState === 'login' && <LoginForm />}
              {loginPageState === '2fa' && <Login2Fa />}
              {loginPageState === 'selectClinic' && <SelectClinicForm />}
              {loginPageState === 'forgotPassword' && <ForgotPasswordForm />}
              {loginPageState === 'resetPassword' && <ResetPasswordForm />}
            </div>

            {isHipaaLink && (
              <Typography variant='body2' component='span'>
                {t('loginSecureText')}{' '}
                <a target='_blank' href='https://www.hipaalink.net/'>
                  {t('moreDetails')}
                </a>
              </Typography>
            )}
          </div>

          {isHipaaLink && !loginModelData.clinics && !loginModelData.isForgotPassword && (
            <div className={styles.leftSide}>
              <img src={image} />

              <div className={styles.content}>
                <Typography variant={isDesktop ? 'h1' : 'h2'} component={isDesktop ? 'h1' : 'h2'} color='#ffffff'>
                  {t('newToHipaaPrefix')}
                  {i18n.resolvedLanguage !== 'hi' && <i>LINK?</i>}
                </Typography>

                <Typography variant='body2' component='span' color='#ffffff'>
                  {t('signupPitch')}
                </Typography>

                <Button onClick={handleSignupClick}>{t('signUp')}</Button>

                <Typography variant='body2' component='span' color='#ffffff'>
                  {t('wantKnowMore')}{' '}
                  <a target='_blank' href='https://www.hipaalink.net/'>
                    {t('clickHere')}
                  </a>
                </Typography>
              </div>

              <div className={styles.backgroundCircle1}></div>
              <div className={styles.backgroundCircle2}></div>
              <div className={styles.backgroundCircle3}></div>
            </div>
          )}
        </>
      ) : (
        <>
          {isHipaaLink && !loginModelData.clinics && !loginModelData.isForgotPassword && (
            <div className={styles.leftSide}>
              <img src={image} />

              <div className={styles.content}>
                <Typography variant={isDesktop ? 'h1' : 'h2'} component={isDesktop ? 'h1' : 'h2'} color='#ffffff'>
                  {t('newToHipaaPrefix')}
                  {i18n.resolvedLanguage !== 'hi' && <i>LINK?</i>}
                </Typography>

                <Typography variant='body2' component='span' color='#ffffff'>
                  {t('signupPitch')}
                </Typography>

                <Button onClick={handleSignupClick}>{t('signUp')}</Button>

                <Typography variant='body2' component='span' color='#ffffff'>
                  {t('wantKnowMore')}{' '}
                  <a target='_blank' href='https://www.hipaalink.net/'>
                    {t('clickHere')}
                  </a>
                </Typography>
              </div>

              <div className={styles.backgroundCircle1}></div>
              <div className={styles.backgroundCircle2}></div>
              <div className={styles.backgroundCircle3}></div>
            </div>
          )}

          <div className={styles.rightSide}>
            <div className={styles.loginContainer}>
              {loading && <Spinner small />}
              {loginPageState === 'login' && <LoginForm />}
              {loginPageState === '2fa' && <Login2Fa />}
              {loginPageState === 'selectClinic' && <SelectClinicForm />}
              {loginPageState === 'forgotPassword' && <ForgotPasswordForm />}
              {loginPageState === 'resetPassword' && <ResetPasswordForm />}
            </div>

            {isHipaaLink && (
              <Typography variant='body2' component='span'>
                {t('loginSecureText')}{' '}
                <a target='_blank' href='https://www.hipaalink.net/'>
                  {t('moreDetails')}
                </a>
              </Typography>
            )}
          </div>
        </>
      )}
    </div>
  );
}
